/** Aynı anda gelen 401'ler tek bir refresh çağrısını bekler. */
let inflight: Promise<string | null> | null = null;

export function refreshOnce(refresh: () => Promise<string | null>): Promise<string | null> {
  if (!inflight) {
    inflight = refresh().finally(() => {
      inflight = null;
    });
  }
  return inflight;
}
